import { RelatedServices } from "/react4xp/parts/related-services/related-services";

export default (props) => <RelatedServices {...props} />;
